const fieldset = "cui-field-fieldset-bb62";
const wrapper = "cui-field-wrapper-rn8e";
const label = "cui-field-label-8ama";
const legend = "cui-field-legend-g5c6";
const description = "cui-field-description-jn0k";
const valid = "cui-field-valid-3hc8";
const warning = "cui-field-warning-pwlm";
const invalid = "cui-field-invalid-xfxm";
const classes = {
  fieldset,
  wrapper,
  label,
  legend,
  "label-text": "cui-field-label-text-x1ew",
  "label-text-optional": "cui-field-label-text-optional-w1wn",
  description,
  "validation-hint": "cui-field-validation-hint-ynjy",
  valid,
  warning,
  invalid,
  "validation-hint-icon": "cui-field-validation-hint-icon-6laa"
};
export {
  classes as default,
  description,
  fieldset,
  invalid,
  label,
  legend,
  valid,
  warning,
  wrapper
};
